import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from "react-redux";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import { baseApi } from "../api/BaseApi";

import loadingReducer from "./loading.slice";
import roleReducer from "./role.slice";
import userReducer from "./user.slice";

const rootReducer = combineReducers({
  user: userReducer,
  role: roleReducer,
  loading: loadingReducer,
  niapApi: baseApi.reducer,
});

const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: [baseApi.reducerPath, "loading"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  // I'm not sure what the issue here is but it doesn't seem to be causing any errors
  // TODO: Investigate type issues here
  // @ts-ignore
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(baseApi.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
